module.exports = __webpack_public_path__ + "img/mobile-6.2d8300f7.png";